import { addDoc, collection, doc, updateDoc } from 'firebase/firestore';

import { db } from '../../config';

export const contactRef = collection(db, 'contacts');

export const addContact = async (
  name: string | null,
  email: string | null,
  phone: string | null,
  category: number | null,
  message: string | null
): Promise<void> => {
  const contactData = {
    category,
    created: new Date(),
    email,
    message,
    name,
    tel: phone,
    updated: new Date()
  };
  const addContactDoc = await addDoc(contactRef, contactData);
  const contactDoc = doc(contactRef, addContactDoc.id);
  await updateDoc(contactDoc, {
    contactId: contactDoc.id
  });
};
